<template>
	<view >
		<view class="container">
			<view class="nav-bar" style="display: flex;">
				<view class="pro_name" style="width: 85%;">
					{{name}}
				</view>
				<view  style="10%" :class="curspart_id!=''?'active':''" @click="showDrawer('showRight')">
					<text>筛选</text>
					<uni-icons type="list" size="30r" :color="curspart_id!=''?'#ff0000':''"></uni-icons>
				</view>
			</view>
			<view style="height: 80rpx;">
				
			</view>
			<view class="item-list" v-for="(item, ki) in items" :key="ki">
				<view class="item-info">
					<navigator :url="'/pages/item/info?proId=' + item.pro_id">
						<view class="item-list-left">
							<image :src="item.pic[0]" class="item-pic"></image>
						</view>
						<view class="item-list-right">
							<view class="item-name">{{item.pro_name}}</view>
							<view v-for="(num, kn) in item.num" :key="kn">
								<view class="item-num">{{num.factory != '' ? num.factory+'：': ''}}{{num.display}}</view>
							</view>
							<view class="item-price" v-if="item.price">
								<text class="price-view ">
									<text class="price-coin">¥</text>
									<text class="price-big">{{item.price}}</text>
								</text>
							</view>
						</view>
					</navigator>
				</view>
			</view>

			<uni-drawer class="udrawer" ref="showRight" mode="right" :mask-click="false" @change="change($event,'showRight')">
				<view class="scroll-view">
					<scroll-view class="scroll-view-box" scroll-y="true">
						<view class="info-content">
							<text class="spart-name" @click="searchItemsBySpart('')">所有</text>
						</view>
						<view class="info-content" @click="searchItemsBySpart(spart.spart_id)" v-for="(spart,index) in spartList" :key="index">
							<text :class=" curspart_id == spart.spart_id? 'spart-name active':'spart-name'">{{spart.spart_name}}</text>
						</view>
						
					</scroll-view>
				</view>
			</uni-drawer>
		
		</view>
	
		
	</view>

</template>

<script>
	import uDrawer from "@/components/uni-drawer/uni-drawer.vue"
	const app = getApp();
	export default {
		components:{
			uDrawer
		},
		data() {
			return {
				items: [],
				name: '',
				spartList: [],
				option: {},
				curspart_id: ''
			}
		},
		onLoad(option) {
			var that = this;
			that.option = option;
			that.name = option.name ? option.name : '';
			// app.getApi('GET', 'gzh/getGzhModelsParams', option, 1, function (data) {
			// 	console.log(data);
			// });
			app.getApi('GET', 'gzh/searchGzhItem', option, 1, function(data) {
				console.log(data);
				that.items = data;

			});
		},
		methods: {
			// 展开搜索
			showDrawer(e) {
				let that = this;
				this.getSearchParts().then(function(result) {
					console.log(result);
					that.$refs[e].open();
				});
			},
			closeDrawer(e) {
				let that = this;
				that.$refs.showRight.close();
			},
			async getSearchParts() {
				let that = this;
				let params = that.option;
				params.level = 'item';
				console.log(params);
				app.getApi('get', 'super/getSearchParts', params, 1, function(data) {
					console.log(data);
					that.spartList = data.spart;
				});
			},
			searchItemsBySpart(spart_id) {
				let that = this;
				let option = that.option;
				that.curspart_id = spart_id;
				option.spart_id = spart_id
				app.getApi('GET', 'gzh/searchGzhItem', option, 1, function(data) {
					that.items = data;
					that.$refs.showRight.close();
				});
			}

		}
	}
</script>

<style scoped>
	.pro_name{
		/* width: 100%; */
		display: inline-block;
		margin: auto;
		padding-right: 10rpx;
		font-size: 24rpx;
		vertical-align: middle;
		text-overflow:ellipsis;
		word-break:keep-all;
		white-space:nowrap;
		overflow: hidden;
	}
	.spart-name{
		color: #aaa;
		font-size: 26rpx;
	}
	.nav-bar{
		position: fixed;
/* 		right: 0;
		left: 0; */
		left: var(--window-left);
		right: var(--window-right);
		z-index: 10;
		/* top: 80rpx; */
		padding: 10rpx;
		background-color: #f7f7f7;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		box-shadow: 0 0 2rpx #000000;
	}
	.udrawer{
		left: var(--window-left);
		right: var(--window-right);
	}
	/* .top-bar-pad {
		position: fixed;
		z-index: 10;
		top: 80rpx;
		height: 60rpx;
		overflow: hidden;
		background-color: #f7f7f7;
		padding: 8rpx;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		box-shadow: 0 0 2rpx rgb(0 0 0 / 85%);
	} */

	.item-list .item-info {
		position: relative;
		background-color: #FFFFFF;
		min-height: 100px;
		padding: 10px;
		border-bottom: 1px solid #eef0ef;
	}

	.scroll-view {
		/* #ifndef APP-NVUE */
		width: 100%;
		height: 100%;
		/* #endif */
		flex: 1
	}

	.scroll-view-box {
		flex: 1;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
	}

	.info-content {
		font-size: 15px;
		flex: 0 0 100%;
		color: #000;
		padding: 8px;
		margin-right: 10px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		border-bottom: 1px solid #F6F6F6;
		text-align: left;
	}

	.active {
		color: #ff0000;
	}
</style>
